"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.FormWrapper = styled_components_1.default.div `
  width: 100%;

  /* lib renders #root anyway, and it has cross height prop */
  & #root {
    height: auto;
  }

  & .form-group:not(:last-child) {
    margin-bottom: ${(0, wl_ui_kit_1.getSizeBy)(4)};
  }
`;
//# sourceMappingURL=styled.js.map